import type { ToOptions } from '@mint/routing';

import type { GetLinkParams } from '../../types/_campaigns/actionsField.js';
import { IntegrationsType } from '../../types/integrations.js';

export const getLink = ({
  tileId,
  channel,
  platformMedia,
  integratedPlatforms,
  campaignId,
  isGhost,
  isOmni,
  selectedMediaPlanId,
}: GetLinkParams): ToOptions => {
  if (!channel) {
    return {};
  }
  const tile = tileId?.toString() ?? '';

  if (platformMedia && isOmni) {
    return {
      to: '/campaign/$campaignId/settings/omni/$platform/$tileId/settings',
      params: {
        campaignId: campaignId.toString(),
        platform: platformMedia,
        tileId: tile,
      },
    };
  }

  if (
    integratedPlatforms.find((pl) => pl.platform === platformMedia)?.type ===
      IntegrationsType.VIRTUAL ||
    isGhost
  ) {
    return {
      to: '/campaign/$campaignId/settings/ghost/$tileId/settings',
      params: {
        campaignId: campaignId.toString(),
        tileId: tile,
      },
      search: selectedMediaPlanId ? { mediaPlan: selectedMediaPlanId } : {}, //remove query params with ghostV2 ff
    };
  }

  return {
    to: '/campaign/$campaignId/settings/ghost/$tileId/settings',
    params: {
      campaignId: campaignId.toString(),
      tileId: tile,
    },
  };
};
